import { render, staticRenderFns } from "./StudentFormDetails.vue?vue&type=template&id=3cbcf9d4&scoped=true"
import script from "./StudentFormDetails.vue?vue&type=script&lang=js"
export * from "./StudentFormDetails.vue?vue&type=script&lang=js"
import style0 from "./StudentFormDetails.vue?vue&type=style&index=0&id=3cbcf9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbcf9d4",
  null
  
)

export default component.exports